// Unit options for inventory items
export const UNIT_OPTIONS = [
  { value: "pcs", label: "Pieces" },
  { value: "set", label: "Set" },
  { value: "liter", label: "Liter" },
  { value: "kg", label: "Kilogram" },
  { value: "meter", label: "Meter" },
  { value: "box", label: "Box" },
  { value: "pack", label: "Pack" },
  { value: "roll", label: "Roll" },
  { value: "tube", label: "Tube" },
  { value: "can", label: "Can" },
  { value: "bottle", label: "Bottle" },
  { value: "drum", label: "Drum" },
  { value: "sack", label: "Sack" },
  { value: "bag", label: "Bag" },
];

// Helper function to get unit label by value
export const getUnitLabel = (value) => {
  const option = UNIT_OPTIONS.find((option) => option.value === value);
  return option ? option.label : value;
};
